import { isNil } from '@lucidlink/tscore';
const HEAD_OBJECT_TARGET_KEY = '.lucid_00000000-0000-0000-0000-000000000000';
export class ObjectStoreHelper {
    static createObjectKey(objectId, objectPrefix) {
        return (isNil(objectPrefix) || objectPrefix === '' ? '' : `${objectPrefix}/`) + objectId;
    }
    static generateLucidSysKey(objectPrefix) {
        return ObjectStoreHelper.createObjectKey(HEAD_OBJECT_TARGET_KEY, objectPrefix);
    }
    static keyPrefix(objectKey) {
        const delimerIndex = objectKey.indexOf('/');
        if (delimerIndex === -1) {
            return undefined;
        }
        return objectKey.slice(0, delimerIndex);
    }
}
